// extracted by mini-css-extract-plugin
export var root = "S_wS";
export var wrapper = "S_sw";
export var image = "S_vW d_w d_y d_W";
export var imageWithHeight = "S_wT";
export var crop = "S_wV";
export var round = "S_wW";
export var fixedHeight = "S_wX";